import { useEffect } from 'react'
import {
  Form,
  Input,
  Button,
  Checkbox,
  Radio,
  Collapse,
  Switch,
  InputNumber,
  Select,
  Tooltip,
  Cascader,
  Typography,
  Drawer,
} from 'antd'
import { useForm } from 'antd/es/form/Form'
import { IconFont, BasTitle, SvgIcon, BasSwitch } from '@/components'
import React, { useState } from 'react'
import { PlusOutlined } from '@ant-design/icons'
import {
  useCheckWafSite,
  useCreateTask,
  useGetComponentList,
  useGetLanguage,
  useGetSiteArea,
  useGetSiteDb,
  useGetSiteDeviceList,
  useGetSiteOs,
  useGetSiteType,
} from '@/pages/waf/site-resource/utils'
import { useGetFingerprint, useCreateTaskV1, useGetCreateSiteSecurityDeviceList } from './utils'
import styled from 'styled-components'
import { Message } from '@/components/message'
import { useNavigate } from 'react-router-dom'
import { checkSiteName } from '@/api/waf-site'

import Markdown from 'react-markdown'
import Editor from '@monaco-editor/react'

const IPV4_SEGMENT = '(?:25[0-5]|2[0-4]\\d|1\\d{2}|[1-9]?\\d)'
const IPV4_ADDRESS = `(?:${IPV4_SEGMENT}\\.){3}${IPV4_SEGMENT}`
const IPV6_ADDRESS = '[0-9a-fA-F:.%]+'
const DOMAIN_ADDRESS = '(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]{2,}'
const SITE_URL_REGEX = new RegExp(
  `^https?:\\/\\/(?:\\[${IPV6_ADDRESS}\\]|${IPV4_ADDRESS}|${DOMAIN_ADDRESS}|localhost)(?::\\d{1,5})?(?:[/?#].*)?$`,
  'i',
)

const normalizeSiteInput = (value: string = '') =>
  value
    .split(/\r?\n/)
    .map(item => item.trim())
    .filter(Boolean)

interface DeviceItem {
  name: string
  device_id: string
  device_list?: DeviceListItem[]
  disabled?: boolean
}

interface DeviceListItem {
  device_type: string
  device_name: string
  device_ip: string
  name: string
  device_id: string
  disabled?: boolean
}

const AddSiteModal = props => {
  const { onOk, onCancel, fingerprint, visible } = props
  const [form] = useForm()
  const { Option } = Select
  const { TextArea } = Input
  const { SHOW_CHILD } = Cascader
  const navigate = useNavigate()
  let [errorPage, setErrorPage] = useState(false)
  let [errorPageList, setErrorPageList] = useState([''])
  // let [redirect, setRedirect] = useState(false)
  let [redirectList, setRedirectList] = useState([''])
  let [responseCode, setResponseCode] = useState(false)
  let [responseCodeList, setResponseCodeList] = useState([''])
  let [timeOut, setTimeOut] = useState(false)
  let [timeOutList, setTimeOutList] = useState<number>(5)
  const [value, setValue] = useState<string>('## Hello world')
  let [mode, setMode] = useState(1)
  let [method, setMethod] = useState('AuthModeNo')
  const [radioValue, setRadioValue] = useState<number>(2)
  let [componentId, setComponentId] = useState<string[]>([])
  let [deviceList, setDeviceList] = useState([])
  let [key, setKey] = useState(0)

  const [cookieSwitch, setCookieSwitch] = useState(false)
  const [initComponentList, setInitComponentList] = useState([])

  const [typeData, getSiteType, typeLoading] = useGetSiteType()
  const [fingerprintData, getFingerprint, fingerprintLoading] = useGetFingerprint()
  const [getSiteArea, siteArea, siteLoading] = useGetSiteArea() // 安全域
  const [getCreateSiteSecurityDeviceList] = useGetCreateSiteSecurityDeviceList() // 创建站点安全设备列表
  const [deviceData, setDeviceData] = useState([]) //站点级联
  const [checkedSiteList, checkSiteList] = useCheckWafSite() // 检查站点
  const [createSite, createSiteLoading] = useCreateTaskV1() // 添加站点
  const [cookieType, setCookieType] = useState('payload_frequency')

  let newComponentList = [{ name: t('全部'), id: '-1' }, ...(fingerprintData?.componentList || [])]

  const [selectedDevices, setSelectedDevices] = useState<string[]>([])

  useEffect(() => {
    getCreateSiteSecurityDeviceList()
      .then(res => {
        const group = res.data.groups.map(item => {
          if (item.devices.length > 0) {
            return {
              device_type: item?.deviceType?.name,
              device_list: item?.devices?.map(device => ({
                device_brand: device?.deviceBrand?.name,
                device_name: device?.deviceName,
                device_ip: device?.deviceIp,
                device_id: device?.id,
                chainId: device?.chainId,
              })),
            }
          }
        })

        console.log('group', group)

        setDeviceData(
          group
            .filter(
              item =>
                item !== undefined &&
                ['FW', 'WAF', 'IPS', 'NTA', 'IDS', 'NDR', 'SOC'].includes(item.device_type),
            )
            .map(item => ({
              ...item,
            })) || [],
        )
      })
      .catch(_ => {})
  }, [])

  const preDeviceListData = (data: any[]): DeviceItem[] =>
    data.map(item => ({
      name: item.device_type,
      device_id: item.device_type,
      device_list: item.device_list?.map(device => ({
        ...device,
        device_type: item.device_type,
        name: `${device.device_name}（${device.device_ip}）`,
        disabled: false,
      })),
      disabled: false,
    }))

  const preVerifyDeviceListData = (data: any[], selectedDevices: string[]): DeviceItem[] => {
    // 获取当前选中的验证默认设备
    const currentSelectedDevices = form.getFieldValue('defaultVerifyDevice') || []
    // 获取第一个选中设备的 chainId
    const firstSelectedDevice = currentSelectedDevices[0]
    const firstSelectedDeviceId = firstSelectedDevice?.[1]

    // 从所有设备中查找第一个选中设备的完整信息
    let firstSelectedDeviceData = null
    for (const group of data) {
      if (group.device_list) {
        const device = group.device_list.find(d => d.device_id === firstSelectedDeviceId)
        if (device) {
          firstSelectedDeviceData = device
          break
        }
      }
    }
    const firstSelectedChainId = firstSelectedDeviceData?.chainId

    return data.map(item => {
      const deviceList = item.device_list?.map(device => {
        // 首先检查是否在关联安全设备中
        const isInSelectedDevices = selectedDevices.includes(device.device_id)

        // 如果有选中的设备，则检查 chainId 是否匹配
        let isChainIdMatch = true
        if (firstSelectedChainId) {
          isChainIdMatch = device.chainId === firstSelectedChainId
        }

        return {
          ...device,
          device_type: item.device_type,
          name: `${device.device_name}（${device.device_ip}）`,
          disabled: !isInSelectedDevices || !isChainIdMatch,
        }
      })

      // 如果该分组下有任何可选设备，则该分组可选
      const hasEnabledDevice = deviceList?.some(device => !device.disabled)

      return {
        name: item.device_type,
        device_id: item.device_type,
        device_list: deviceList,
        disabled: !hasEnabledDevice,
      }
    })
  }

  const onDeviceSelect = (val, selectedOptions) => {
    let arr = selectedOptions?.map(el => el[1])
    setDeviceList(arr)
  }

  const checkSiteNameDuplicate = (val, index, arr) => {
    // 判断当前元素是否是重复的元素
    // 且当前元素不是第一个重复的
    let duplicatedArr: string[] = []
    arr.forEach(el => {
      if (arr.indexOf(el) !== arr.lastIndexOf(el) && !duplicatedArr.includes(el)) {
        duplicatedArr.push(el)
      }
    })
    if (duplicatedArr.includes(val)) {
      let i = arr.indexOf(val)
      return i !== index
    } else {
      return false
    }
  }

  const onCheckSite = () => {
    form
      .validateFields(['site'])
      .then(() => {
        setKey((key = key + 1))
        const val = form.getFieldValue('site') || ''
        const siteList = normalizeSiteInput(val)
        checkSiteList({ site: siteList, site_name: siteList })
          .then(res => {
            form.setFieldValue('sites', res.data)
          })
          .catch(_ => {})
      })
      .catch(_ => {})
  }
  const checkedSiteName = (value: string) =>
    new Promise((resolve, reject) => {
      checkSiteName({ site_name: value })
        .then(res => {
          if (res.code === 200) {
            resolve(true)
          } else resolve(false)
        })
        .catch(error => {
          resolve(false)
        })
    })

  const submitHandler = values => {
    console.log('values', values)
    let site = values.sites?.filter(item => !item.status)
    if (site.length === 0) {
      Message.error(t('站点无效，不可添加'))
      return
    }
    let o = {
      waf_name: mode !== 3 ? values.fileName : undefined,
      device_id_list: mode === 3 ? deviceList?.map(item => item.device_id) : undefined,
    }
    const componentData = values.component?.filter(item => item !== -1) || []
    console.log('sites', values.sites)

    const obj = {
      site: values.sites?.map(item => ({
        url: item.site,
        name: item.site_name,
      })),
      // 设备配置
      ...o,

      // web认证
      authMode: method,
      protocolAuth: {
        username: method === 'AuthModeProtocolAuth' ? values.username : undefined,
        password: method === 'AuthModeProtocolAuth' ? values.password : undefined,
      },
      cookieAuth:
        method === 'AuthModeCookieAuth' ? (cookieSwitch ? '' : values.cookieAuth) : undefined,
      cookieRefreshFrequency: {
        cookieRefreshType: values.cookieRefreshType,
        cookieRefreshSeconds:
          values.cookieRefreshType === 'customizable_frequency' ? values.cookieRefreshSeconds : 10,
      },
      os: values.os,
      db: values.db,
      wafDetectSwitch: values.wafDetectSwitch,
      language: values.language,
      component:
        componentId?.filter(item => item !== '-1') ||
        values?.component?.filter(item => item !== '-1') ||
        [],
      areaId: values.areaId,
      remark: values.remark,
      componentSwitch: values.componentSwitch ? 2 : 3,
      deviceIdList: values?.deviceIdList?.map(item => (typeof item === 'object' ? item[1] : item)),
      defaultVerifyDevice: values?.defaultVerifyDevice?.map(item =>
        typeof item === 'object' ? item[1] : item,
      ),
    }
    console.log('obj', obj)
    createSite({ site: { ...obj } })
      .then(() => {
        onOk()
        setMethod('AuthModeNo')
        form.resetFields()
      })
      .catch(_ => {})
  }

  return (
    <DrawerBox
      width={760}
      onClose={() => {
        onCancel()
        setMethod('AuthModeNo')
        form.resetFields()
      }}
      open={visible}
      title={<BasTitle title={t('添加站点')} />}
      bodyStyle={{ height: 'calc(100vh - 108px)', overflow: 'scroll' }}
      maskClosable={false}
      destroyOnClose
      footer={
        <div style={{ textAlign: 'right' }}>
          <Button
            onClick={() => {
              onCancel()
              setMethod('AuthModeNo')
              form.resetFields()
            }}
            style={{ marginRight: 8 }}
          >
            {t('取消')}
          </Button>
          <Button type="primary" onClick={form.submit}>
            {t('确定')}
          </Button>
        </div>
      }
    >
      <Form
        form={form}
        onFinish={submitHandler}
        layout={'horizontal'}
        initialValues={{
          areaId: '0',
          language: '1',
          db: '1',
          os: '1',
          authMode: 'AuthModeNo',
          sites: [],
          cookieRefreshSeconds: 10,
          cookieRefreshType: 'payload_frequency',
          componentSwitch: false,
        }}
        colon={false}
      >
        <SiteBox>
          <Form.Item
            label={
              <>
                <span>{t('站点')}</span>
                <Tooltip
                  title={t('输入Web应用程序的站点URL，与账号不同域的站点需要验证')}
                  getPopupContainer={() => document.body}
                >
                  <IconFont style={{ marginLeft: 6, color: '#666' }} type={'icon-bangzhu'} />
                </Tooltip>
              </>
            }
            name={'site'}
            rules={[
              { required: true, message: '请输入站点' },
              {
                validator: (_, val, callback) => {
                  if (!val) {
                    callback()
                    return
                  }
                  const sites = normalizeSiteInput(val)
                  if (sites.length > 100) {
                    callback('最多添加100个')
                    return
                  }
                  const invalidSite = sites.find(site => !SITE_URL_REGEX.test(site))
                  if (invalidSite) {
                    callback('站点格式错误，请输入合法的 http/https 链接')
                    return
                  }
                  callback()
                },
                validateTrigger: 'onChange',
              },
            ]}
          >
            <TextArea
              style={{ width: 638 }}
              autoSize={{ minRows: 5, maxRows: 10 }}
              placeholder={t('多个站点之间以换行分隔，最多添加100个')}
            />
          </Form.Item>
          <Button style={{ marginLeft: 10 }} onClick={onCheckSite}>
            {t('确定')}
          </Button>
        </SiteBox>
        <div key={key} style={{ maxHeight: 300, overflow: 'auto' }}>
          <Form.List name="sites">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, value, ...restField }) => (
                  <SiteContainer key={key} err={form.getFieldValue('sites')[key].status}>
                    <div className="site">
                      <span className="title">{t('站点：')}</span>
                      <Form.Item
                        {...restField}
                        name={[name, 'site']}
                        style={{ width: '220px', margin: '0' }}
                      >
                        <Typography.Text
                          ellipsis={{
                            tooltip: {
                              getPopupContainer: () => document.body,
                            },
                          }}
                        >
                          {form.getFieldValue('sites')[key].site}
                        </Typography.Text>
                      </Form.Item>
                    </div>
                    <div className="site">
                      <span className="title">{t('站点名称：')}</span>
                      <Form.Item
                        {...restField}
                        name={[name, 'site_name']}
                        style={{ width: '220px', margin: '0' }}
                        validateFirst
                        rules={[
                          { max: 50, message: '站点名称最多为50字', validateTrigger: 'onChange' },
                          {
                            validator: (_, val, callback) => {
                              let status = form.getFieldValue('sites')[key].status
                              if (status) {
                                callback()
                              } else {
                                let sites = form
                                  .getFieldValue('sites')
                                  ?.filter(item => !item.status)
                                  ?.map(item => item.site_name)
                                let r = checkSiteNameDuplicate(val, key, sites)
                                if (r) {
                                  callback('站点名称不可重复')
                                } else {
                                  callback()
                                }
                                callback()
                              }
                            },
                            validateTrigger: 'onSubmit',
                          },
                          {
                            validator: (_, val, callback) => {
                              if (val?.length > 0) {
                                checkedSiteName(val).then(res => {
                                  if (res) {
                                    callback()
                                  } else {
                                    callback('站点名称已存在')
                                  }
                                })
                              } else {
                                callback()
                              }
                            },
                            validateTrigger: 'onSubmit',
                          },
                        ]}
                      >
                        <Input style={{ width: '208px' }} placeholder="请输入" />
                      </Form.Item>
                    </div>
                    {form.getFieldValue('sites')[key].status && (
                      <div style={{ color: '#f53f3f', lineHeight: '30px' }}>
                        <IconFont
                          type={'icon-group43'}
                          style={{ fontSize: '14px', marginRight: 4 }}
                        />

                        <span>{form.getFieldValue('sites')[key].status}</span>
                      </div>
                    )}
                  </SiteContainer>
                ))}
              </>
            )}
          </Form.List>
        </div>
        <ContentBox>
          <div className="main-title" style={{ marginTop: 20 }}>
            {t('基础配置')}
          </div>
          <Form.Item
            name="areaId"
            label={t('安全域')}
            style={{ paddingLeft: 4 }}
            rules={[{ required: true }]}
          >
            <Select placeholder={t('请选择安全域')} loading={siteLoading} style={{ width: 360 }}>
              {siteArea?.map(item => (
                <Option key={item.id} value={item.id}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <div className="web-auth">
            <div className="web-label" style={{ marginRight: '56px' }}>
              {t('Web认证')}
            </div>
            <Form.Item name={'authMode'} rules={[{ required: true }]}>
              <Radio.Group
                value={method}
                defaultValue={method}
                onChange={e => {
                  setMethod(e.target.value)
                }}
              >
                <Radio value="AuthModeNo" style={{ marginRight: '32px' }}>
                  {t('无认证')}
                </Radio>
                <Radio value="AuthModeProtocolAuth" style={{ marginRight: '32px' }}>
                  {t('协议认证')}
                </Radio>
                <Radio value="AuthModeCookieAuth" style={{ marginRight: '32px' }}>
                  {t('Cookies认证')}
                </Radio>
              </Radio.Group>
            </Form.Item>
          </div>
          <AuthBox style={{ paddingLeft: 4 }}>
            {method === 'AuthModeProtocolAuth' && (
              <>
                <Form.Item
                  label={t('用户名')}
                  name="username"
                  rules={[{ required: true }, { max: 128, message: t('用户名最多为128位') }]}
                >
                  <Input placeholder={t('请输入用户名')} style={{ width: 360 }} />
                </Form.Item>
                <Form.Item
                  label={t('密码')}
                  name="password"
                  rules={[{ required: true }, { max: 32, message: t('密码最多为32位') }]}
                >
                  <Input.Password placeholder={t('请输入密码')} style={{ width: 360 }} />
                </Form.Item>
              </>
            )}
            {method === 'AuthModeCookieAuth' && (
              <>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 15 }}>
                  <span>{t('动态获取cookie开关：')}</span>
                  <Switch
                    checkedChildren={t('开')}
                    unCheckedChildren={t('关')}
                    checked={cookieSwitch}
                    onChange={e => {
                      setCookieSwitch(e)
                    }}
                  />
                </div>
                {cookieSwitch && (
                  <>
                    <Form.Item
                      label={t('动态获取频率')}
                      name="cookieRefreshType"
                      rules={[{ required: true }]}
                      className="form-item-cookie-refresh"
                    >
                      <Radio.Group
                        onChange={val => {
                          setCookieType(val.target.value)
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', height: '32px' }}>
                          <Radio value="payload_frequency">
                            {t('payload 频率')}{' '}
                            <Tooltip
                              getPopupContainer={() => document.body}
                              title={t('在每次发送payload前自动更新Cookie')}
                            >
                              <IconFont type="icon-tishi" style={{ color: '#909090' }} />
                            </Tooltip>
                          </Radio>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <Radio
                            value="customizable_frequency"
                            style={{
                              width: '90px',
                            }}
                          >
                            {t('指定频率')}
                          </Radio>
                        </div>
                        {cookieType === 'customizable_frequency' && (
                          <div className="form-item-cookie-refresh-seconds-box">
                            <Form.Item
                              label=""
                              style={{ width: '180px' }}
                              className="form-item-cookie-refresh-seconds"
                            >
                              <Form.Item
                                name="cookieRefreshSeconds"
                                rules={[{ required: true, message: t('请输入频率') }]}
                                noStyle
                              >
                                <InputNumber
                                  style={{ width: '320px' }}
                                  min={1}
                                  max={60}
                                  precision={0}
                                  placeholder={t('请输入频率')}
                                />
                              </Form.Item>
                              <span className="unit">
                                {t('秒')}
                                <Tooltip
                                  getPopupContainer={() => document.body}
                                  title={t('发送payload前检测历史cookie是否过期，过期后再次获取')}
                                >
                                  <IconFont
                                    type="icon-tishi"
                                    style={{ color: '#909090', marginLeft: '5px' }}
                                  />
                                </Tooltip>
                              </span>
                            </Form.Item>
                          </div>
                        )}
                      </Radio.Group>
                    </Form.Item>
                  </>
                )}
                {!cookieSwitch && (
                  <Form.Item label="Cookie" name="cookieAuth" rules={[{ required: true }]}>
                    <Input placeholder={t('请输入Cookie')} style={{ width: 360 }} />
                  </Form.Item>
                )}
              </>
            )}
          </AuthBox>
          <Form.Item
            name="deviceIdList"
            label={t('关联安全设备')}
            style={{ display: 'flex', flexDirection: 'row', marginTop: '20px' }}
          >
            <Cascader
              multiple
              maxTagCount="responsive"
              allowClear
              fieldNames={{
                label: 'name',
                value: 'device_id',
                children: 'device_list',
              }}
              style={{ width: '360px' }}
              options={preDeviceListData(deviceData)}
              onChange={(value: any, selectedOptions) => {
                onDeviceSelect(value, selectedOptions)
                // 只保存具体设备ID，不包含设备类型
                const deviceIds = value.map((v: any[]) => v[1]).filter(Boolean)
                setSelectedDevices(deviceIds)
                // 当关联安全设备变化时，清空验证默认设备的选择
                form.setFieldValue('defaultVerifyDevice', [])
              }}
              placeholder={t('请选择安全设备')}
              showCheckedStrategy={SHOW_CHILD}
            />
          </Form.Item>
          <Form.Item
            name="defaultVerifyDevice"
            label={t('验证默认设备')}
            style={{ display: 'flex', flexDirection: 'row', marginTop: '20px' }}
          >
            <Cascader
              multiple
              maxTagCount="responsive"
              allowClear
              fieldNames={{
                label: 'name',
                value: 'device_id',
                children: 'device_list',
              }}
              style={{ width: '360px' }}
              options={preVerifyDeviceListData(deviceData, selectedDevices)}
              onChange={(value, selectedOptions) => {
                // 1. 获取所有可选 device_id
                const enabledDeviceIds: string[] = []
                preVerifyDeviceListData(deviceData, selectedDevices).forEach(group => {
                  group.device_list?.forEach(device => {
                    if (!device.disabled) {
                      enabledDeviceIds.push(device.device_id)
                    }
                  })
                })

                // 2. 过滤 value，只保留可选的 device_id
                const filteredValue = value.filter((v: any[]) => enabledDeviceIds.includes(v[1]))

                // 3. 设置过滤后的值
                form.setFieldValue('defaultVerifyDevice', filteredValue)

                // 4. 你原有的逻辑
                onDeviceSelect(filteredValue, selectedOptions)
              }}
              placeholder={t('请选择验证默认设备')}
              showCheckedStrategy={SHOW_CHILD}
            />
          </Form.Item>
          <Form.Item
            name="wafDetectSwitch"
            label={t('WAF防护检测开关')}
            style={{ display: 'flex', flexDirection: 'row', marginTop: '20px' }}
          >
            <BasSwitch />
          </Form.Item>
          <div className="main-title">{t('攻击用例发送规则')}</div>
          <div style={{ marginBottom: 20, color: '#666' }}>
            {t('发送规则：')}
            <span>{t('默认发送操作系统、数据库、开发语言、影响组件对应配置的攻击用例')}</span>
          </div>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: 4,
            }}
          >
            <div className="main-title">{t('指纹信息')}</div>
          </div>
          <Form.Item label={t('操作系统')} name={'os'} style={{ paddingLeft: 4, marginBottom: 24 }}>
            <Select placeholder={t('请选择')} loading={siteLoading} style={{ width: 360 }}>
              {fingerprintData?.osList?.map(item => (
                <Option key={item.id} value={item.id}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label={t('数据库')} name={'db'} style={{ paddingLeft: 4, marginBottom: 24 }}>
            <Select placeholder={t('请选择')} loading={siteLoading} style={{ width: 360 }}>
              {fingerprintData?.dbList?.map(item => (
                <Option key={item.id} value={item.id}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label={t('开发语言')}
            name={'language'}
            style={{ paddingLeft: 4, marginBottom: 20 }}
          >
            <Select placeholder={t('请选择')} loading={siteLoading} style={{ width: 360 }}>
              {fingerprintData?.languageList?.map(item => (
                <Option key={item.id} value={item.id}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <ComponentBox>
            <div style={{ marginTop: 40, width: 130 }}>{t('影响组件')}</div>
            <div className="component-box">
              <div className="filter-box">
                <Form.Item
                  name="componentSwitch"
                  style={{ paddingLeft: 20 }}
                  className="filter"
                  valuePropName="checked"
                >
                  <Checkbox value={2}>{t('用例过滤')}</Checkbox>
                </Form.Item>
                <Tooltip
                  title={t('勾选后系统将会按选择影响组件进行执行用例过滤')}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <SvgIcon
                    name={t('提示')}
                    style={{ width: '14px', height: '14px', marginTop: 2 }}
                  />
                </Tooltip>
              </div>
              <Form.Item
                name={'component'}
                style={{ width: 360, paddingLeft: 4 }}
                className="component"
              >
                <Select
                  placeholder={t('请选择影响组件')}
                  loading={fingerprintLoading}
                  mode="multiple"
                  allowClear
                  showSearch
                  showArrow
                  optionFilterProp="name"
                  maxTagCount={4}
                  maxTagTextLength={4}
                  defaultValue={componentId}
                  onChange={(e: any, keys) => {
                    setComponentId(keys?.map(it => it.value))
                    e.some(groups => {
                      if (groups === '-1') {
                        const arr = []
                        newComponentList
                          ?.filter(item => item.id !== '-1')
                          ?.map(item => arr.push(item.id))
                        arr.push('-1')
                        form.setFieldsValue({
                          component: arr,
                        })
                        setComponentId(arr.slice(0))
                        return
                      }
                      if (groups !== '-1' && e.length === newComponentList.length - 1) {
                        const arr = []
                        newComponentList
                          ?.filter(item => item.id !== '-1')
                          ?.map(item => arr.push(item.id))
                        arr.push('-1')
                        form.setFieldsValue({
                          component: arr,
                        })
                        setComponentId(arr.slice(0))
                        return
                      }
                      setComponentId(e)
                    })
                  }}
                  onDeselect={e => {
                    if (form.getFieldValue('component').length === newComponentList.length) {
                      let arr = []
                      form.getFieldValue('component').map((item, i) => {
                        if (item !== e && item !== '-1') {
                          arr.push(item)
                        }
                      })
                      form.setFieldsValue({
                        component: arr,
                      })
                      setComponentId(arr)
                    }
                    if (e === '-1') {
                      form.setFieldsValue({
                        component: [],
                      })
                      setComponentId([])
                    }
                  }}
                >
                  {newComponentList?.map(item => (
                    <Option name={item.name} value={item.id} key={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          </ComponentBox>
          <div className="main-title">{t('其它')}</div>
          <Form.Item name="remark" label={t('备注')} style={{ marginTop: 20, marginBottom: 0 }}>
            <TextArea
              rows={4}
              placeholder={t('请输入（100字）')}
              style={{ width: 710 }}
              maxLength={100}
            />
          </Form.Item>
        </ContentBox>
      </Form>
    </DrawerBox>
  )
}

export default AddSiteModal

const DrawerBox = styled(Drawer)`
  .ant-drawer-close {
    width: 36px;
    height: 36px;
    background: #d8d6f4;
    box-shadow: -1px 4px 10px 0px #c7c7c7;
    border-radius: 6px;
    border: none;
    margin-right: 0px;
    color: #4238c9;
    font-size: 16px;
    font-weight: 500;
    position: absolute;
    right: 0px;
    top: 0px;
    transition: transform 0.3s ease;

    &:hover {
      transform: translate(-10px, 8px);
      box-shadow: 0 0 0 0;
    }

    .ant-drawer-close-x {
      width: 100%;
      height: 100%;
      line-height: 36px;
      text-align: center;
    }
  }
  .ant-drawer-header {
    height: 56px;
    background: #f2f0ff;
    border-bottom: none;
    margin: 0;
  }
`

const Description = styled.div`
  display: inline-block;
  font-size: 12px;
  color: #999999;
  margin-bottom: 22px;
`
const SiteBox = styled.div`
  display: flex;
  align-items: flex-end;
  .ant-form-item {
    margin-bottom: 0;
  }
`
const ContentBox = styled.div`
  .main-title {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    line-height: 21px;
    margin-bottom: 20px;
  }
  .ant-form-item-label {
    width: 130px;
    text-align: left;
  }
  .web-auth {
    display: flex;
    align-items: center;
    padding-left: 4px;
    flex-direction: row;
    .web-label {
      margin-right: 16px;

      &::before {
        display: inline-block;
        margin-right: 4px;
        color: #ff4d4f;
        font-size: 14px;
        font-family: SimSun, sans-serif;
        line-height: 1;
        content: '*';
      }
    }
    .ant-form-item {
      margin-bottom: 0;
    }
    margin-bottom: 14px;
    margin-top: 24px;
  }
`
const ComponentBox = styled.div`
  display: flex;
  .title-box {
    margin-left: 4px;
    display: flex;
    align-items: center;
    margin-bottom: 2px;
    width: 356px;
    justify-content: space-between;
  }
  .component-box {
    display: flex;
    align-items: flex-end;
    flex-direction: column;
  }
  .filter-box {
    display: flex;
    align-items: center;
  }
  .ant-form-item-control-input-content {
    display: flex;
    align-items: center;
  }
  .filter {
    width: 108px;
    margin-bottom: 0;
  }
`

const Divider = styled.div`
  margin-bottom: 18px;
  border-bottom: 1px dashed #dee1e4;
`
const SiteContainer = styled.div`
  display: flex;
  padding: 10px 0;
  background: ${props => (props.err ? '#FEF2F2' : '#f8f9fb')};
  border-radius: 8px;
  margin-bottom: 8px;
  .site {
    display: flex;
    align-items: flex-start;
  }
  .title {
    //margin-bottom: 22px;
    color: #86909c;
    margin-left: 16px;
    line-height: 30px;
  }
  .reason {
    color: #f53f3f;
    line-height: 30px;
    margin-left: 10px;
  }
`
const DeviceContainer = styled.div`
  background: #f8f9fb;
  //background: #FEF2F2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 30px;
  padding-left: 12px;
  padding-right: 26px;
  border-radius: 8px;
  margin-bottom: 10px;
  .flex {
    display: flex;
  }
  .title {
    width: 70px;
    color: #86909c;
    margin-right: 6px;
  }
  .value {
    width: 100px;
  }
  .value1 {
    width: 200px;
  }
`

const BasId = styled.div`
  margin-bottom: 20px;
  .ant-form-item-row {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    justify-content: flex-start;
    .ant-form-item-label {
      padding: 0;
    }
    .ant-form-item-control {
      width: auto;
    }
  }
`
const AuthBox = styled.div`
  .form-item-cookie-refresh {
    margin-bottom: 15px;
    .ant-form-item-label {
      padding-bottom: 0;
      margin-right: 10px;
    }
    .ant-form-item-row {
      height: 32px;
      display: flex;
      flex-direction: row;
      align-items: baseline;
      .ant-form-item-control {
        width: auto;
        #cookieRefreshType {
          display: flex;
          flex-direction: row;
          align-items: baseline;
        }
      }
    }
  }
  .form-item-cookie-refresh-seconds-box {
    display: flex;
    align-items: baseline;
    .form-item-cookie-refresh-seconds {
      margin-bottom: 0;
      margin-right: 10px;
      .ant-form-item-control-input-content {
        display: flex;
        align-items: center;
        .unit {
          margin-left: 10px;
          display: flex;
          align-items: center;
        }
      }
    }
  }
`
